import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.rule_types'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Rule types',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: [1, 143], // 143 - "Read rules"
      update: 150,
      delete: -1,
      downloadList: -1,
      uploadList: -1
    }
  },

  controllerDefaultParams: (state, getters, rootState) => {
    return {
      fetch: { org_id: getSessionContext().org_id }
    }
  },

  columns: (state, getters, rootState) => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating: true, isNumeric: true },
      { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true },
      { name: 'rule_enforcement_level_id', label: 'Enforcement level', field: 'rule_enforcement_level_id', editable: true, references: (rootState['rules.ruleEnforcementLevels'] || {}).list, required: true }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
